// @flow
import React from "react";
import type { GazelleData, GazelleObject } from "../../types/gazelle.js";
import { List } from "immutable";
import { findRef } from "../../utils/gazelle.js";
import VerticalStackElement from "./VerticalStackElement.js";
import "./VerticalStackContainer.scss";

export default function VerticalStackContainer(props: {
  gazelleData: GazelleData
}) {
  const { gazelleData } = props;
  const verticalStackData = gazelleData.find(
    obj => obj.get("type") == "vertical-stack-container"
  );
  if (verticalStackData == null) {
    return <span>Couldn't find a vertical stack</span>;
  }

  var verticalStackElements = [];
  verticalStackData
    .getIn(["attributes", "elements"], List())
    .forEach(elementRef => {
      let obj = findRef(gazelleData, elementRef);
      if (obj != null) {
        verticalStackElements.push(obj);
      }
    });

  return (
    <div className="gazelle-preview__vertical-stack-container">
      {verticalStackElements.map(elem =>
        <VerticalStackElement
          key={elem.get("id")}
          gazelleData={gazelleData}
          verticalStackElementData={elem}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/gazelle/VerticalStackContainer.js